/* sticker-marquee.js — Sticker marquee (rebrand 2026, W3 lane 3.3 BR5).

   The marquee MOTION is pure CSS (section-stockists-panel.css): duration
   from --marquee-duration, pause on :hover / :focus-within, static under
   prefers-reduced-motion. This element only mirrors the theme editor's
   shopify:section:select / deselect into a paused state class
   (CONTRACTS §14.3). Because it toggles a class rather than driving the
   animation, it can never restart a motion the reduced-motion CSS
   disabled — under `reduce` the track has `animation: none` and the
   class is inert.

   Editor lifecycle (CONTRACTS §14): guarded define; all state lives on
   the instance (multiple instances per page are independent — events are
   matched against data-section-id); listeners bind in connectedCallback
   with an AbortController signal and are removed by a single abort() in
   disconnectedCallback; shopify:section:load / unload need no extra
   handling — the editor re-injects the section markup, so the custom
   element lifecycle re-runs and connectedCallback resets the baseline. */

if (!customElements.get('sticker-marquee')) {
  customElements.define(
    'sticker-marquee',
    class StickerMarquee extends HTMLElement {
      connectedCallback() {
        // Fresh baseline on every (re)connect — editor re-injection safe.
        this.classList.remove('sticker-marquee__scroller--paused');
        this.listenersController = new AbortController();
        const { signal } = this.listenersController;
        document.addEventListener('shopify:section:select', (event) => this.setEditorPaused(event, true), { signal });
        document.addEventListener('shopify:section:deselect', (event) => this.setEditorPaused(event, false), {
          signal,
        });
      }

      disconnectedCallback() {
        this.listenersController.abort();
      }

      setEditorPaused(event, paused) {
        if (!event.detail || event.detail.sectionId !== this.dataset.sectionId) return;
        this.classList.toggle('sticker-marquee__scroller--paused', paused);
      }
    }
  );
}
